import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const AdmissionIIT = () => {
  const homeMenu = [
    // { label: "Awards & Achievements", link: "/awardsAcheivements" },

    {
      label: "Awards & Achievements",
      link: "/awardsAcheivements",
      subMenu: [
        { label: "Accolades & Achievements", link: "/awardsAcheivements" },
        { label: "Students Achievements", link: "/studentsAcheivements" },
      ],
    },

    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },
    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },

    {
      label: "CUET",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/admissions-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page admission_txt">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Admissions IIT"
                breadEnd="Admissions IIT"
                breadMid="Admissions IIT"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>
                <i>Hard work and Perseverance Always Pay…..</i>
              </p>
              <p>
                With great joy and pride, we share the outstanding achievement
                of our learners, Inhaas Virmani, Aryan Bajaj, Siddharth Mishra,
                Tanish Agarwal, Suchit Srivastava and Bhakti Bansal who have
                made their Alma mater &amp; their parents proud and have
                perfected as role models for their successors by cracking the
                competitive entrance examination and securing a seat in the most
                prestigious Engineering Institute, Indian Institute of
                Technology.
              </p>
              <p>
                Congratulations on your well-deserved success! You are an
                inspiration!
              </p>
              <div className="">
                <div className="text-box gallery-sec">
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/trikitha.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">AGASTYA TRIKHA</p>
                        <p>IIT, Delhi</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/anirudh.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">ANIRUDDHA BHATTACHARYA</p>
                        <p>IIT, Delhi</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/arav.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">AARAV SINHA</p>
                        <p>IIT, Delhi</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/suchit-srivastava.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">Suchit Srivastava</p>
                        <p>IIT, Hyderabad</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/bhakti-bansal.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">Bhakti Bansal</p>
                        <p>IIT, Bombay</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Inhaas-Virmani.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">Inhaas Virmani</p>
                        <p>IIT, Delhi</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Tanish-Agarwal.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">Tanish Agarwal</p>
                        <p>IIT, Delhi</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/siddharth-mishra.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">Siddharth Mishra</p>
                        <p>IIT, Madras</p>
                      </div>
                    </div>
                  </div>
                  <div className="gallery">
                    <div className="galleryBox">
                      <div className="gallery-pic">
                        <LazyLoad>
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/aryan-bajaj.jpg"
                            className="img-fluid"
                            alt="Lotus Valley School, Gurgaon"
                          />
                        </LazyLoad>
                      </div>
                      <div className="gallery-text">
                        <p className="font-normal">Aryan Bajaj</p>
                        <p>IIT, Banaras Hindu University</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default AdmissionIIT;
